<section class="mb-4 p-3 shadow border bg-white rounded-3">
  <div class="row g-3">
    <div class="d-sm-none">
      <div class="fs-4 fw-medium text-primary-emphasis text-break">
        {{ profile.username }}
      </div>
      <div class="fw-medium text-muted text-break">
        {{ profile.userEmail }}
      </div>
    </div>
    <div class="profile-image col-12 col-sm-6 col-md-4 col-xxl-3">
      <button class="btn p-0 w-100 h-100" (click)="onOpenProfileImageModal()">
        <nz-image [imageUrl]="profileImageUrl" imageAlt="Профилна снимка"/>
      </button>
    </div>
    <div class="col-12 col-sm-6 col-md-8 col-xxl-9">
      <div class="w-100 h-100 d-flex flex-wrap flex-column justify-content-between">
        <div class="d-none d-sm-block">
          <div class="fs-4 fw-medium text-primary-emphasis text-break">
            {{ profile.username }}
          </div>
          <div class="fw-medium text-muted text-break">
            {{ profile.userEmail }}
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-12 col-md-6 col-lg-7 col-xl-6 col-xxl-4">
            <div class="dropdown">
              <a class="w-100 btn btn-sm btn-nz-primary dropdown-toggle" href="#" role="button"
                 data-bs-toggle="dropdown"
                 aria-expanded="false">
                <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
                Редактиране на профила
              </a>
              <ul class="dropdown-menu dropdown-menu-end">
                <li>
                  <button class="dropdown-item"
                          (click)="onOpenProfileImageModal()">
                    <i class="dropdown-item-icon text-muted fa-solid fa-camera" aria-hidden="true"></i>
                    Промяна на профилна снимка
                  </button>
                </li>
                <li>
                  <button class="dropdown-item"
                          (click)="onOpenUserDefaultAddressModal()">
                    <i class="dropdown-item-icon text-muted fa-solid fa-map-location-dot" aria-hidden="true"></i>
                    Промяна на адрес по подразбиране
                  </button>
                </li>
                <li>
                  <hr class="dropdown-divider">
                </li>
                <li>
                  <button class="dropdown-item"
                          (click)="onOpenPasswordModal()">
                    <i class="dropdown-item-icon text-muted fa-solid fa-lock" aria-hidden="true"></i>
                    Промяна на парола
                  </button>
                </li>
                <li>
                  <button class="dropdown-item"
                          (click)="onOpenEmailModal()">
                    <i class="dropdown-item-icon text-muted fa-solid fa-at" aria-hidden="true"></i>
                    Промяна на електронна поща
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="row g-4">
  <div class="col-12 col-sm">
    <button class="w-100 p-3 dashboard-card text-nowrap text-center shadow border btn btn-light"
            (click)="showUserRatingInfo()">
      <h4 class="mb-1">
        <nz-user-rating [rating]="profile.userRating" [hiddenValue]="true"/>
      </h4>
      <p class="text-muted small mb-0 d-flex justify-content-center">
        <span>Рейтинг ({{ profile.userRating }})</span>
      </p>
    </button>
  </div>
  <div class="col-6 col-sm">
    <a class="w-100 p-3 dashboard-card text-nowrap text-center shadow border btn btn-light"
       [routerLink]="[appRoutes.root, appRoutes.profile, profile.userId]"
       [queryParams]="{menuId:7}">
      <h4 class="mb-1"
          [ngClass]="profile.purchaseCount !== 0 ? 'text-success' : 'text-secondary'">
        {{ profile.purchaseCount }}
      </h4>
      <p class="text-muted small mb-0">Покупки</p>
    </a>
  </div>
  <div class="col-6 col-sm">
    <a class="w-100 p-3 dashboard-card text-nowrap text-center shadow border btn btn-light"
       [routerLink]="[appRoutes.root, appRoutes.profile, profile.userId]"
       [queryParams]="{menuId:8}">
      <h4 class="mb-1"
          [ngClass]="profile.saleCount !== 0 ? 'text-success' : 'text-secondary'">
        {{ profile.saleCount }}
      </h4>
      <p class="text-muted small mb-0">Продажби</p>
    </a>
  </div>
</section>
<section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
  <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
    <i class="me-2 fa-solid fa-bullhorn" aria-hidden="true"></i>
    <h6 class="m-0">Моите обяви</h6>
  </header>
  <ul class="m-0 list-unstyled">
    <li class="table-hover-row">
      <div class="p-3 d-flex justify-content-between border-bottom">
        <span>Активни обяви:</span>
        <strong [ngClass]="profile.activeAdCount !== 0 ? 'text-dark' : 'text-secondary'">
          {{ profile.activeAdCount }}
        </strong>
      </div>
    </li>
    <li class="table-hover-row">
      <div class="p-3 d-flex justify-content-between border-bottom">
        <span>Обяви започвщи скоро:</span>
        <strong [ngClass]="profile.notStartedAdCount !== 0 ? 'text-dark' : 'text-secondary'">
          {{ profile.notStartedAdCount }}
        </strong>
      </div>
    </li>
    <li class="table-hover-row">
      <div class="p-3 d-flex justify-content-between border-bottom">
        <span>Обяви завършили със сделка:</span>
        <strong [ngClass]="profile.completedWithDealAdCount !== 0 ? 'text-dark' : 'text-secondary'">
          {{ profile.completedWithDealAdCount }}
        </strong>
      </div>
    </li>
    <li class="table-hover-row">
      <div class="p-3 d-flex justify-content-between border-bottom">
        <span>Обяви завършили без сделка:</span>
        <strong [ngClass]="profile.completedWithoutDealAdCount !== 0 ? 'text-dark' : 'text-secondary'">
          {{ profile.completedWithoutDealAdCount }}
        </strong>
      </div>
    </li>
    <li class="table-hover-row">
      <div class="p-3 d-flex justify-content-between border-bottom">
        <span>Общо:</span>
        <strong [ngClass]="profile.totalAdCount !== 0 ? 'text-dark' : 'text-secondary'">
          {{ profile.totalAdCount }}
        </strong>
      </div>
    </li>
  </ul>
  <footer class="bg-light p-3">
    <div class="row g-3 justify-content-end">
      <div class="col-12 col-sm-5 col-md-4 col-xl-3">
        <a class="w-100 btn btn-sm btn-nz-primary"
           [routerLink]="[appRoutes.root, appRoutes.adCrate]">
          <i class="fa-solid fa-plus-circle"></i>
          <span class="ms-2">Добави обява</span>
        </a>
      </div>
      <div class="col-12 col-sm-5 col-md-4 col-xl-3">
        <a class="w-100 btn btn-sm btn-nz-primary"
           [routerLink]="[appRoutes.root, appRoutes.profile, profile.userId]"
           [queryParams]="{'menuId': 4}">
          <i class="fa-solid fa-eye"></i>
          <span class="ms-2">Преглед на обявите</span>
        </a>
      </div>
    </div>
  </footer>
</section>
<section class="my-4 shadow border bg-white rounded-3 overflow-hidden">
  <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
    <i class="me-2 fa-solid fa-wallet" aria-hidden="true"></i>
    <h6 class="m-0">Портфейл</h6>
  </header>
  <ul class="m-0 list-unstyled">
    <li class="table-hover-row">
      <div class="p-3 d-flex justify-content-between border-bottom">
        <span>Текущ баланс:</span>
        <strong
          [ngClass]="profile.currentBalance === 0 ? 'text-secondary' : profile.currentBalance > 0 ? 'text-success' : 'text-danger'">
          <span>{{ profile.currentBalance }} лв.</span>
        </strong>
      </div>
    </li>
  </ul>
  <footer class="bg-light p-3">
    <div class="row g-3 justify-content-end">
      <div class="col-12 col-sm-5 col-md-4 col-xl-3">
        <button class="w-100 btn btn-sm btn-nz-primary"
                (click)="onOpenPaymentModal()">
          <i class="fa-solid fa-plus-circle"></i>
          <span class="ms-2">Захранване на сметка</span>
        </button>
      </div>
    </div>
  </footer>
</section>
<section class="shadow border bg-white rounded-3 overflow-hidden">
  <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
    <i class="me-2 fa-solid fa-user-shield" aria-hidden="true"></i>
    <h6 class="m-0">Активност на профила</h6>
  </header>
  <ul class="m-0 list-unstyled">
    <li class="table-hover-row">
      <div class="p-3 d-flex justify-content-between border-bottom">
        <span>Последно влизане:</span>
        <strong class="text-dark">{{ profile.lastLogin | date:'dd.MM.yyyy г.' }}</strong>
      </div>
    </li>
    <li class="table-hover-row">
      <div class="p-3 d-flex justify-content-between border-bottom">
        <span>Дата на регистрация:</span>
        <strong class="text-dark">{{ profile.registrationDate | date:'dd.MM.yyyy г.' }}</strong>
      </div>
    </li>
  </ul>
</section>
